// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__lobGO","counter__button":"styles_counter__button__w052h","counter__button_grey":"styles_counter__button_grey__keoAm","disabled":"styles_disabled__8GyV_"};